module.exports = function getResource(label) {
    const resources = {
        gotIt: 'Got it',
        undo: 'Undo'
    };

    return resources[label];
};
